// extracted by mini-css-extract-plugin
export default {"container":"jgl_C9"};